// src/components/Auth/ProtectedRoute.js
import React from 'react';
import { Navigate, useLocation, Outlet } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth'; // useAuth hook'unu import et
import LoadingSpinner from '../common/LoadingSpinner'; // Yükleme göstergesi

const ProtectedRoute = () => {
  const { isAuthenticated, loading } = useAuth(); // Context'ten auth durumu ve yükleme durumunu al
  const location = useLocation();

  // 1. AuthContext hala başlangıç kontrolünü yapıyorsa (loading true ise)
  if (loading) {
    // Yükleme bitene kadar bekle, bir yükleme göstergesi göster
    return <LoadingSpinner overlay label="Oturum kontrol ediliyor..." />; // Tüm ekranı kaplayan yükleme
  }

  // 2. Yükleme bitti, kimlik doğrulama durumunu kontrol et
  if (!isAuthenticated) {
    // Kullanıcı giriş yapmamışsa, login sayfasına yönlendir.
    // Geldikleri sayfayı (location) state olarak gönderelim ki,
    // giriş yaptıktan sonra oraya geri dönebilsinler.
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Kullanıcı giriş yapmışsa, istenen iç içe route'ları (children) render et.
  // AppRoutes'daki <Route element={<AdminLayout />}> gibi yapıları render etmek için Outlet kullanılır.
  return <Outlet />;
};

export default ProtectedRoute;